import { Color } from '../constants/color'

export type BemloLogoProps = {
  className?: string
  color?: Color
}

export const BemloLogo = ({
  className,
  color = Color.BLUE,
}: BemloLogoProps) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 684 142"
  >
    <path
      fill={color}
      d="M56.4 139c-6.4 0-11.6-5.1-11.6-11.5v-33H11.6C5.2 94.5 0 89.4 0 83V57c0-6.4 5.2-11.5 11.6-11.5h33.2v-33C44.8 6.1 50 1 56.4 1h26.2C89 1 94.2 6.1 94.2 12.5v33h33.2c6.4 0 11.6 5.1 11.6 11.5v26c0 6.4-5.2 11.5-11.6 11.5H94.2v-49H44.8v73l20.6-20.6c2.2-2.1 5.2-3.4 8.2-3.4h20.6v33c0 6.4-5.2 11.5-11.6 11.5H56.4ZM185 2.9V139h52.7c25.6 0 42.2-16 42.2-38 0-17-10.8-29-24-32.3a30.3 30.3 0 0 0 19.7-29.2c0-21.2-15-36.7-41.5-36.7H185Zm26.2 56.3v-34h18.6c13 0 19.7 6.5 19.7 16.9 0 10.4-7.3 17-19.5 17h-18.8Zm0 57.8V81h22c13.2 0 20.1 7.6 20.1 18.3 0 11-7.7 17.7-20.6 17.7h-21.5Zm102.2-36c.6-8.6 8-18.6 21.2-18.6 14.6 0 20.8 9.3 21.1 18.7h-42.3Zm44.9 24.7c-3.1 8.4-9.7 14.4-21.6 14.4-12.7 0-23.3-9-23.9-21.5h67.8c0-.4.4-4.3.4-7.9 0-30.4-17.6-49-46.8-49-24.2 0-46.6 19.6-46.6 49.8a48 48 0 0 0 49 50.5c23.2 0 38.2-13.6 43-30l-21.4-6.3Zm58.7 33.4V83.8c0-10.4 6.6-18.7 17.8-18.7 11.5 0 16.7 7.7 16.7 18v56H477V83.8c0-10.2 6.6-18.7 17.5-18.7 11.8 0 16.8 7.7 16.8 18v56H536V77.8c0-25.3-16.7-36-34.3-36a33 33 0 0 0-30 15.8C467 47.5 456.5 42 443.7 42c-10.5 0-22.6 5-27.8 14.2V44.6h-24.4V139H417Zm157 0V0h-25.5v139.1H574Zm60.4-20.3c-12.6 0-24.1-9.3-24.1-27 0-17.8 11.5-26.9 24-26.9 12.6 0 24.1 9 24.1 27 0 17.8-11.5 26.8-24 26.8Zm0-77.1c-28.3 0-49.7 21-49.7 50.1 0 29 21.4 50.2 49.7 50.2A48.6 48.6 0 0 0 684 91.8a48.5 48.5 0 0 0-49.6-50.1Z"
    />
  </svg>
)
